import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=629a986e&scoped=true"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Info.vue?vue&type=style&index=0&id=629a986e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "629a986e",
  "3fcc31fb"
  
)

export default component.exports